module.exports = __webpack_public_path__ + "img/cc-mastercard.b1b13647.svg";